<template lang="html">
  <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="48" width="48" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 48 48.000001">
   <g transform="translate(0 -1004.4)">
    <circle :style="{'fill': circleFill}" r="24" cx="24" cy="1028.4"/>
    <g style="stroke:#27435c;stroke-width:2.3196" transform="matrix(.51492 0 0 .51492 9.09 1013.5)">
     <path style="stroke:#27435c;stroke-width:2.3196;fill:#f7b563" d="m52.723 55.956h-47.534c-.134 0-.248-.098-.268-.23l-4.918-32.458c-.025-.164.102-.312.268-.312h57.37c.166 0 .293.148.268.312l-4.918 32.458c-.02.132-.134.23-.268.23z"/>
     <g style="stroke:#27435c;stroke-width:2.3196">
      <path style="stroke:#27435c;stroke-width:2.3196;fill:#b5885b" d="m53.956 22.956v-15.232c0-.424-.344-.768-.768-.768h-30.797c-.27 0-.52-.141-.658-.373l-2.553-4.254c-.139-.231-.389-.373-.658-.373h-13.798c-.424 0-.768.344-.768.768v20.232h50z"/>
     </g>
     <rect style="stroke:#27435c;stroke-width:2.3196;fill:#fff" height="7" width="42" y="15.956" x="7.956"/>
    </g>
   </g>
  </svg>

</template>

<script>
export default {
  name: 'Record',
  props: {
    circleFill: {
      default: '#bdcdda'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/menu/Record.vue